import axios from "axios";
import sessionStorage from "../storage/SessionStorage";
import localStorage from "../storage/LocalStorage";

class Request {
	handleAuthenticationError() {
		localStorage.setPathName("logoutMessage", "common.errors.sessionTerminated");
		sessionStorage.clear();
		window.location.href = "/login";
	}
	async post(config) {
		const defaultConfig = {
			method: "post",
		};

		const finalConfig = {
			...defaultConfig,
			...config,
		};

		try {
			const res = await axios.request(finalConfig);
			return res.data;
		} catch (err) {
			console.log("Error in post: ", err);
			console.log("error response request: ", err.response);
			if (err.response) {
				if (axios.isCancel(err)) {
					return { canceled: true };
				}
				if (err?.response?.status === 403 || err?.response?.data?.error?.type === "authentication_error") {
					this.handleAuthenticationError();
					return err?.response?.data || { error: "Error" };
				}
				return err?.response?.data || { error: "Error" };
			}
			return {
				error: err,
			};
		}
	}

	async get(config = {}) {
		const defaultConfig = {
			method: "get",
		};
		const finalConfig = {
			...defaultConfig,
			...config,
		};
		try {
			const res = await axios.request(finalConfig);
			return res.data;
		} catch (err) {
			console.log("Error in get: ", err);
			if (axios.isCancel(err)) {
				return { canceled: true };
			}
			if (
				err?.response?.status === 401 ||
				err?.response?.status === 403 ||
				err?.response?.data?.error?.type === "authentication_error"
			) {
				this.handleAuthenticationError();
				return err?.response?.data || { error: "Error" };
			}
			return {
				error: err,
			};
		}
	}

	async put(config) {
		const defaultConfig = {
			method: "put",
		};
		const finalConfig = {
			...defaultConfig,
			...config,
		};
		try {
			const res = await axios.request(finalConfig);
			console.log("response in put: ", res);
			return res.data;
		} catch (err) {
			console.log("Error in put: ", err);
			if (axios.isCancel(err)) {
				return { canceled: true };
			}
			if (
				err?.response?.status === 401 ||
				err?.response?.status === 403 ||
				err?.response?.data?.error?.type === "authentication_error"
			) {
				this.handleAuthenticationError();
				return err?.response?.data || { error: "Error" };
			}
			return {
				error: err,
			};
		}
	}

	async patch(config) {
		const defaultConfig = {
			method: "patch",
		};
		const finalConfig = {
			...defaultConfig,
			...config,
		};
		try {
			const res = await axios.request(finalConfig);
			console.log("response in patch: ", res);
			return res.data;
		} catch (err) {
			console.log("Error in patch: ", err);
			if (axios.isCancel(err)) {
				return { canceled: true };
			}
			if (
				err?.response?.status === 401 ||
				err?.response?.status === 403 ||
				err?.response?.data?.error?.type === "authentication_error"
			) {
				this.handleAuthenticationError();
				return err?.response?.data || { error: "Error" };
			}
			return {
				error: err,
			};
		}
	}

	async delete(config) {
		const defaultConfig = {
			method: "delete",
		};
		const finalConfig = {
			...defaultConfig,
			...config,
		};
		try {
			const res = await axios.request(finalConfig);
			console.log("response in delete: ", res);
			return res.data;
		} catch (err) {
			console.log("Error in delete: ", err);
			if (axios.isCancel(err)) {
				return { canceled: true };
			}
			if (
				err?.response?.status === 401 ||
				err?.response?.status === 403 ||
				err?.response?.data?.error?.type === "authentication_error"
			) {
				this.handleAuthenticationError();
				return err?.response?.data || { error: "Error" };
			}
			return err?.response?.data || { error: "Error" };
		}
	}
}

export default new Request();
